import React from "react";
import "../style/ErrorBoundary.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("تم التقاط خطأ في ErrorBoundary:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <h1>حدث خطأ غير متوقع 😓</h1>
          <p>{this.state.error?.message || "حدث خطأ أثناء عرض الصفحة."}</p>
          <button onClick={this.handleRetry}>إعادة المحاولة</button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
